<div class="flex-between-center w-full mb-4 whitespace-nowrap">
    <div class="flex-between-center md:flex-start-center gap-x-1 md:gap-x-3 text-xs">
        <div class="text-xs text-sub-text max-md:hidden">MKT Cap</div>
        <div class="text-xs text-sub-text md:hidden">MC</div>

        <div class="max-md:flex-1 h-8 px-1 md:px-2 rounded bg-[#FEE384]/20 border-[#FEE384] border flex-center-center">
            <span class="max-md:text-2xs">Large > $10M</span>
        </div>

        <div class="max-md:flex-1 h-8 px-1 md:px-2 rounded bg-[#CBF484]/20 border-[#CBF484] border flex-center-center">
            <span class="max-md:text-2xs">Mid $10M-$100K</span>
        </div>

        <div class="max-md:flex-1 h-8 px-1 md:px-2 rounded bg-[#96EEDB]/20 border-[#96EEDB] border flex-center-center">
            <span class="max-md:text-2xs">Small < $100K</span>
        </div>
    </div>

    <nz-radio-group class="shrink-0 grow text-right max-md:hidden" [(ngModel)]="dateRange" [disabled]="loading" (ngModelChange)="durationChange()">
        <label nz-radio-button *ngFor="let item of dateRangeList" [nzValue]="item.value">{{item.label}}</label>
    </nz-radio-group>

    <div class="ml-4 max-md:hidden">
        <app-chain-select [(selectedChain)]="chain" (selectedChainChange)="fetchData()"></app-chain-select>
    </div>
</div>

<div class="md:hidden w-full flex-between-center items-center gap-x-1 mb-3">
    <nz-radio-group [(ngModel)]="dateRange" [disabled]="loading" (ngModelChange)="durationChange()">
        <label nz-radio-button *ngFor="let item of dateRangeList" [nzValue]="item.value">{{item.label}}</label>
    </nz-radio-group>

    <app-chain-select [(selectedChain)]="chain" (selectedChainChange)="fetchData()"></app-chain-select>
</div>

<!-- Treemap -->
<div
    class="w-full gap-0.5 flex-start-center flex-col md:flex-row md:flex-start-center min-h-[200px] h-[782px] md:h-[350px] rounded overflow-hidden"
    appLoading
    [loading]="loading"
    [ngClass]="{
        'h-[240px]':!treemapList.length && !loading
    }"
>
    <div *ngIf="!treemapList.length && !loading" class="w-full h-full flex-center-center gap-x-0.5 relative max-md:flex-col">
        <div class="flex-1 bg-[#FEE38433] max-md:w-full md:h-full"></div>
        <div class="flex-1 bg-[#CBF48433] max-md:w-full md:h-full"></div>
        <div class="flex-1 bg-[#96EEDB33] max-md:w-full md:h-full"></div>

        <div class="absolute top-0 left-0 w-full h-full flex-center-center">
            <span class="text-sub-text text-xs">Wallets in this Watchlist currently have no MEME buys data.</span>
        </div>
    </div>

    <ng-container *ngFor="let item of treemapList">
        <app-base-treemap
            *ngIf="item.data.length"
            [type]="item.type"
            [valueType]="'watchlist'"
            [data]="item.data"
            [detailBtnVisible]="false"
            [style.width]="percentageMap[item.type] * 100 + '%'"
            class="flex-shrink-0 block max-md:!flex-1 max-md:!w-full"
        ></app-base-treemap>
    </ng-container>
</div>
